// Per-page-info mutation-queue key. Unlike furniture/eref/ecall (whose keys live with the sidebar
// that owns their edits), a page has no sidebar and its coordinate drag is its only queue-serialized
// mutation — so the key lives next to its sole consumer, useCoordinateCommit. The "Set page name"
// modal PATCHes the same endpoint but bypasses the queue (see useCoordinateCommit's header comment).
export const pageQueueKey = (pageInfoId: number) => `page-${pageInfoId}`
